<template>
  <TitleWrapper
    :title="`DAILY_STUDENTS_ATTENDANCE`"
    additional-name="Settings"
    :is-buttons-hidden="true"
    :is-right-bar-button-hidden="true"
  />
  <UITabs v-model="activePage" :tabs-list="tabsList" />
  <div v-if="activePage === FEATURES_TABS.GENERAL">
    <NoRecordFound />
  </div>
  <div v-else-if="activePage === FEATURES_TABS.PERMISSION">
    <FeatureSettingsPermissionsView
      :feature-name="MYQAMPUS_FEATURE_NAMES.STUDENTS_DAILY_ATTENDANCE"
    />
  </div>
  <div v-else-if="activePage === FEATURES_TABS.NOTIFICATION">
    <DailyStudentAttendanceNotificationView />
  </div>
</template>

<script>
import { MYQAMPUS_FEATURE_NAMES } from '@/src/constants/feature-name-constants'
import FeatureSettingsPermissionsView from '@/src/router/views/settings/system-settings/FeatureSettingsPermissionsView.vue'
import NoRecordFound from '@src/components/BaseComponent/NoRecordFound.vue'
import { FEATURES_TABS_LIST, FEATURES_TABS } from '@src/constants/general-constants.js'
import TitleWrapper from '@components/TitleWrapper.vue'
import UITabs from '@src/components/UiElements/UITabs.vue'
import { pluralToSingular } from '@/src/utils/generalUtil'
import { mapState, mapGetters } from 'vuex'
import DailyStudentAttendanceNotificationView from '@/src/router/views/settings/notifications/attendance/daily-student-attendance/DailyStudentAttendanceNotificationView.vue'
export default {
  name: 'Settings',
  components: {
    UITabs,
    DailyStudentAttendanceNotificationView,
    TitleWrapper,
    NoRecordFound,
    FeatureSettingsPermissionsView,
  },
  page: {
    title: 'Features Settings',
  },
  data() {
    return {
      FEATURES_TABS,
      MYQAMPUS_FEATURE_NAMES,
      tabsList: FEATURES_TABS_LIST,
      activePage: FEATURES_TABS.GENERAL,
    }
  },

  computed: {
    ...mapState({
      ...mapGetters('featureNaming', ['sectionName']),
    }),
  },

  methods: {
    pluralToSingular,
  },
}
</script>
